export enum OfficeSpaceRentalMenuEnum {
    overview = 0,
    rentUnitSizeWise,
    properties
}